var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new_link"},[_c('router-link',{attrs:{"to":_vm.href}},[_c('a',[_c('font-awesome-icon',{staticClass:"label",attrs:{"icon":"caret-right"}}),_c('span',{staticClass:"link-text"},[_vm._v(_vm._s(_vm.label))])],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }